module.exports = __webpack_public_path__ + "img/module-brand-logo.0c076cd1.svg";